import { API_PATH } from '../constants/defaults'
import { BaseAPI } from './BaseAPI'

export class MailerAPI extends BaseAPI {
  public async postMail(subject: string, to: number, body: string): Promise<string> {
    return this.api
      .post(`${API_PATH.MAILER}`, {
        subject,
        to,
        body,
      })
      .then((response) => response.data)
  }
}
